'use strict';

var React = require('react');

var SvgPasskeyFilledIcon = function SvgPasskeyFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 3c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5-1.567-3.5-3.5-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.417c-.707-.271-1.468-.417-2.25-.417-2.278 0-4.378 1.235-5.484 3.227l-.437.786c-.495.891.15 1.987 1.17 1.987h8.612c-.14-.278-.214-.586-.214-.9v-2.175c-.822-.358-1.397-1.177-1.397-2.131v-.377Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.81 16.648c-.106-.163-.163-.353-.163-.548v-2.983h-.074c-.691 0-1.259-.53-1.318-1.206-.003-.039-.005-.078-.005-.117v-.919c0-1.588 1.287-2.875 2.875-2.875s2.875 1.287 2.875 2.875v.919c0 .73-.593 1.323-1.323 1.323h-.43v.16l.384.469c.416.508.228 1.271-.372 1.53l.26.211c.48.392.492 1.121.025 1.529l-.72.63c-.458.399-1.163.302-1.495-.206l-.519-.792Zm2.19-5.773c0 .483-.392.875-.875.875s-.875-.392-.875-.875.392-.875.875-.875.875.392.875.875Z"
  }));
};
SvgPasskeyFilledIcon.displayName = "PasskeyFilledIcon";

exports.SvgPasskeyFilledIcon = SvgPasskeyFilledIcon;
